/* eslint-disable */
import role from "./App-role";

const authority = {
    Home:           [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    LogIn:          [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    LogOut:         [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    Signup:         [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    Sna:            [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    digitalAI:      [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    Gis:            [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer],
    Help:           [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    Shop:           [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer],
    UserSetting:    [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer],
    AdminSetting:   [role.root, role.admin, role.developer],
    RootSetting:    [role.root, role.developer],
    ErrorPage:      [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    SupportPage:    [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    ServicePage:    [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    PrivacyPage:    [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
    InvitePage:    [role.root, role.admin, role.reviewer, role.editor, role.reader, role.developer, role.anonymous],
};

export default authority;
